import { Provider } from 'react-redux';

import { Game } from './components/game/Game';
import { store } from './store';

export const App = (): JSX.Element => {
  return (
    <Provider store={store}>
      <Game />
    </Provider>
  );
};
